export default __webpack_public_path__ + "static/media/newblp_Clients_sel.e4a14c5a.svg";